'use client'

import type {ReactNode} from 'react'
import {useSignal, viewport} from '@tma.js/sdk-react'
import SplashScreen from '@/components/screens/SplashScreen'

export default function OrientationWrapper({children}: { children: ReactNode }) {
    const width = useSignal(viewport.width)
    const height = useSignal(viewport.height)

    return height >= width
        ? children
        : (
            <SplashScreen isBrowser={false}>
                <h1 className="text-center text-3xl">Portrait orientation required</h1>
            </SplashScreen>
        )
}
